/**
 * Funzioni API per le capacità UI per ruolo (Admin — product-service).
 *
 * Endpoint:
 *   GET /api/products/admin/ui-capabilities  → RoleCapabilitiesMap
 *   PUT /api/products/admin/ui-capabilities  → RoleCapabilitiesMap (solo SYSTEM_CONFIGURATION)
 */

import { createServiceClient } from '../../api/client.js';
import type { RoleCapabilitiesMap } from './capabilities-types.js';

/** Client parzialmente applicato per il product-service. */
const productApi = createServiceClient('product');

/**
 * Recupera la mappa corrente ruolo → capacità UI.
 * GET /api/products/admin/ui-capabilities
 */
export function fetchUiCapabilities(): Promise<RoleCapabilitiesMap> {
  // NB: createServiceClient('product') prefissa già SERVICE_URLS.product (/api/products):
  // il path qui è relativo, altrimenti si ottiene /api/products/api/products/... → 404.
  return productApi<RoleCapabilitiesMap>('/admin/ui-capabilities');
}

/**
 * Aggiorna la mappa ruolo → capacità UI.
 * PUT /api/products/admin/ui-capabilities
 */
export function updateUiCapabilities(map: RoleCapabilitiesMap): Promise<RoleCapabilitiesMap> {
  return productApi<RoleCapabilitiesMap>('/admin/ui-capabilities', {
    method: 'PUT',
    body: map,
  });
}
